export default __webpack_public_path__ + "static/media/proj1.b9566ff0.png";